import { NavigateFunction } from "react-router-dom";

export const persistReturnToSearchUrl = () => {
    const existingReturnUrl = sessionStorage.getItem("returnToSearchUrl");
    if (!existingReturnUrl) {
        sessionStorage.setItem(
            "returnToSearchUrl",
            window.location.pathname + window.location.search,
        );
    }
};

export const navigateBackToSearch = (navigate: NavigateFunction) => {
    const returnToSearchUrl = sessionStorage.getItem("returnToSearchUrl");
    if (returnToSearchUrl) {
        sessionStorage.removeItem("returnToSearchUrl");
        navigate(returnToSearchUrl);
        return;
    }
    window.history.back();
};
